import React from "react";
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';

interface NoDataDonutChartProps {
  width?: string | number;
  height?: string | number;
  innerRadius?: number;
  outerRadius?: number;
  noDataColor?: string;
  noDataText?: string;
  className?: string;
}

const NoDataDonutChart: React.FC<NoDataDonutChartProps> = ({
  width = "100%",
  height = "100%",
  innerRadius = 55,
  outerRadius = 70,
  noDataColor = '#E5E7EB',
  noDataText = "No data",
  className = ""
}) => {
  const noDataDisplay = [
    { name: 'No Data', value: 100 },
  ];

  return (
    <div className={`w-full h-full relative ${className}`}>
      <ResponsiveContainer width={width} height={height}>
        <PieChart>
          <Pie
            data={noDataDisplay}
            dataKey="value"
            nameKey="name"
            cx="50%"
            cy="50%"
            innerRadius={innerRadius}
            outerRadius={outerRadius}
            paddingAngle={0}
            strokeWidth={0}
          >
            <Cell fill={noDataColor} />
          </Pie>
        </PieChart>
      </ResponsiveContainer>
      <div className="absolute inset-0 flex items-center justify-center">
        <span className="text-base text-[#6B7280] dark:text-white/60">{noDataText}</span>
      </div>
    </div>
  );
};

export default NoDataDonutChart; 